const getLogTriggerMessage = (triggerStep) => {
  if (triggerStep?.workflowName) {
    return `Started by ${triggerStep?.workflowName} workflow`;
  }

  if (triggerStep?.appSlug === 'webhook') {
    return `Started by ${triggerStep?.isSynchronousWebhook ? 'Synchronous Webhook' : 'Webhook'}`;
  }

  if (triggerStep?.appSlug === 'schedule') {
    return `Started by Schedule - ${triggerStep?.message}`;
  }

  return `Started by ${triggerStep?.message}`;
};

export default getLogTriggerMessage;
